import Link from 'next/link';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import styles from './leftNavigation.module.scss';
import AccordionWrapper from '../accordion/accordionWrapper';

export default function LeftNavigation({
  slug = '',
  items = [],
  backLink = null,
}) {
  const [currentPath, setCurrentPath] = useState('');

  useEffect(() => {
    if (slug) {
      setCurrentPath(`/${slug}`);
    }
  }, [slug, items]);

  const renderListChildItems = (childItems) => {
    return (
      <ul className={styles.menuList}>
        {childItems?.map((item, index) => {
          const key = `childItems${index}`;
          const selected = currentPath === item.link;
          return (
            <li
              key={key}
              className={`${styles.menuListItem} ${
                selected ? styles.menuListItemSelected : ''
              }`}
              data-testid={item?.label}
            >
              <Link href={item?.link} className={styles.itemTitle}>
                {item?.label}
              </Link>
            </li>
          );
        })}
      </ul>
    );
  };

  const data = items?.map((item, index) => {
    const key = `section-${index}`;
    return (
      <AccordionWrapper
        key={key}
        id={key}
        itemProp="mainEntity"
        head={parse(
          `<div itemProp="name" data-testid='${item.title}'>${item.title}</div>`
        )}
        body={renderListChildItems(item.childItems)}
        containerStyle={styles.accordionItem}
        borderTopHidden={index === 0}
        headStyle={styles.accordionItemHeader}
      />
    );
  });

  return (
    <div>
      {backLink && backLink?.link !== currentPath && (
        <div className={styles.returnLinkWrapper}>
          <Link href={backLink.link} className={styles.returnLink}>
            {backLink.label}
          </Link>
        </div>
      )}
      <div className={styles.leftNavigation}>{data}</div>
    </div>
  );
}

LeftNavigation.propTypes = {
  items: PropTypes.array,
  slug: PropTypes.string,
  backLink: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
  }),
};
